export class CalendarParams {
	technical_specialist_id: number;
	timecard_status: string;
	week_number: number;
	year_number: number;
}